<ng-template
  #featureItem
  let-feature="feature"
  let-tooltipPosition="tooltipPosition"
  [ngTemplateType]="FeatureItemTplType"
>
  <rt-feature-item
    [label]="feature.label | translate"
    [tooltip]="feature.tooltip ? (feature.tooltip | translate) : undefined"
    [icon]="feature.altIcon"
    [tooltipPosition]="tooltipPosition"
    [isBold]="feature.isBold"
  />
</ng-template>

<ng-template
  #extensionItem
  let-feature="feature"
  let-tooltipPosition="tooltipPosition"
  [ngTemplateType]="FeatureItemTplType"
>
  <rt-feature-item
    [label]="feature.label | translate"
    [tooltip]="feature.tooltip ? (feature.tooltip | translate) : undefined"
    [icon]="'extension'"
    [tooltipPosition]="tooltipPosition"
  />
</ng-template>

<ng-template
  #featureGroups
  [ngTemplateType]="FeatureColumnTplType"
  let-groups="groups"
  let-tooltipPosition="tooltipPosition"
>
  @for (group of groups; track trackByIndex; let last = $last) {
    @for (feature of group; track trackByLabel($index, feature)) {
      <ng-container
        *ngTemplateOutlet="
          featureItem;
          context: { feature: feature, tooltipPosition: tooltipPosition }
        "
      />
    }
    @if (!last) {
      <rt-divider margin-tb-small />
    }
  }
</ng-template>

<ng-template
  #addonGroup
  let-addons="addons"
  let-tooltipPosition="tooltipPosition"
  [ngTemplateType]="AddonGroupTplType"
>
  @for (addon of addons; track trackByLabel($index, addon)) {
    <ng-container
      *ngTemplateOutlet="
        extensionItem;
        context: { feature: addon, tooltipPosition: tooltipPosition }
      "
    />
  }
</ng-template>

<ng-container *ngTemplateOutlet="isLoaded ? content : null" />

<ng-template #content>
  <div class="content">
    <div [class.disabled]="viewMode === ViewMode.StaffingAgency" class="section">
      <div class="heading-box">
        <span
          [innerHTML]="
            'app.pricing.plan_picker_2024.compare.x_slots' | translate: { count: startSlots }
          "
        ></span>
      </div>
      <div class="features" padding-top-medium>
        <ng-container
          *ngTemplateOutlet="
            featureGroups;
            context: { groups: compareFeaturesModel[BillingPlanTier.Start] }
          "
        />
      </div>
      <rt-box variant="padding-small" margin-tb-medium>
        <div>
          <div class="addon-header">
            {{ 'app.pricing.plan_picker_2024.compare.optional_addons' | translate }}
          </div>
          <div class="features">
            <ng-container
              *ngTemplateOutlet="
                addonGroup;
                context: { addons: compareAddonsModel[BillingPlanTier.Start].optional }
              "
            />
          </div>
        </div>
      </rt-box>
      @if (showStartDowngradeWarning) {
        <div>
          {{
            'app.pricing.plan_picker_2024.start_downgrade_warning'
              | translate: { count: startDowngradeFeaturesMissingCount }
          }}
        </div>
      }
    </div>
    <div [class.disabled]="viewMode === ViewMode.StaffingAgency" class="section middle">
      <div class="heading-box">
        @if (viewMode === ViewMode.Migration) {
          <rt-icon name="add-circle-outline" colorToken="colorIconSuccessDefault" />
        }
        <span
          [innerHTML]="'app.pricing.plan_picker_2024.compare.unlimited_slots' | translate"
        ></span>
      </div>
      <div class="features" padding-top-medium>
        <ng-container
          *ngTemplateOutlet="
            featureGroups;
            context: { groups: compareFeaturesModel[BillingPlanTier.Grow] }
          "
        />
      </div>
      <rt-box variant="padding-small" margin-tb-medium>
        <div>
          <div class="addon-header">
            {{ 'app.pricing.plan_picker_2024.compare.optional_addons' | translate }}
          </div>
          <div class="features">
            <ng-container
              *ngTemplateOutlet="
                addonGroup;
                context: { addons: compareAddonsModel[BillingPlanTier.Grow].optional }
              "
            />
          </div>
        </div>
      </rt-box>
    </div>
    <div class="section">
      <div class="heading-box">
        @if (viewMode === ViewMode.Migration) {
          <rt-icon name="add-circle-outline" colorToken="colorIconSuccessDefault" />
        }
        <span
          [innerHTML]="'app.pricing.plan_picker_2024.compare.unlimited_slots' | translate"
        ></span>
      </div>
      <div class="features" padding-top-medium>
        <ng-container
          *ngTemplateOutlet="
            featureGroups;
            context: {
              groups: compareFeaturesModel[BillingPlanTier.Optimize],
              tooltipPosition: 'left',
            }
          "
        />
      </div>
      <rt-box variant="vertical padding-small" margin-top-medium>
        <div>
          <div class="addon-header">
            {{ 'app.pricing.plan_picker_2024.compare.included_addons' | translate }}
          </div>
          <div class="features">
            <ng-container
              *ngTemplateOutlet="
                addonGroup;
                context: {
                  addons: compareAddonsModel[BillingPlanTier.Optimize].included,
                  tooltipPosition: 'left',
                }
              "
            />
          </div>
        </div>
        <div margin-top-small-xx>
          <div class="addon-header">
            {{ 'app.pricing.plan_picker_2024.compare.optional_addons' | translate }}
          </div>
          <div class="features">
            <ng-container
              *ngTemplateOutlet="
                addonGroup;
                context: {
                  addons: compareAddonsModel[BillingPlanTier.Optimize].optional,
                  tooltipPosition: 'left',
                }
              "
            />
          </div>
        </div>
      </rt-box>
    </div>
  </div>
</ng-template>
